
import {defineComponent} from 'vue';
import Header from '@/components/Header.vue';
import GameScreen from '@/components/GameScreen.vue';
import {showShareScreen} from '@/state/game';
import ShareScreen from '@/components/ShareScreen.vue';

export default defineComponent({
	components: {ShareScreen, GameScreen, Header},
	setup() {
		return {
			showShareScreen,
		};
	},
});
